import ApiService from "@/core/services/api.service";

// Actions
export const FETCH_SERVICE_VISIT_COMMENTS = "fetchServiceVisitComments";
export const FETCH_SERVICE_VISIT_COMMENT = "fetchServiceVisitComment";
export const SAVE_SERVICE_VISIT_COMMENT = "saveServiceVisitComment";
export const UPDATE_SERVICE_VISIT_COMMENT = "updateServiceVisitComment";
export const DELETE_SERVICE_VISIT_COMMENT = "deleteServiceVisitComment";
export const FETCH_SERVICE_VISIT_COMMENT_OPTIONS = "fetchServiceVisitCommentOptions";
export const FETCH_SERVICE_VISIT_COMMENT_STATUSES = "fetchServiceVisitCommentStatuses";
export const UPDATE_SERVICE_VISIT_COMMENT_STATUS = "updateServiceVisitCommentStatus";

// Mutations
export const SET_LOADING = "setLoadingServiceVisitComment";
export const SET_SERVICE_VISIT_COMMENTS = "setServiceVisitComments";

const state = {
  errors: [],
  serviceVisitComments: [],
  isLoadingServiceVisitComment: false
};

const getters = {
  isLoadingServiceVisitComment() {
    return state.isLoadingServiceVisitComment;
  },
  getServiceVisitComments() {
    return state.serviceVisitComments;
  }
};

const actions = {
  [FETCH_SERVICE_VISIT_COMMENTS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-visit-comments" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_SERVICE_VISIT_COMMENT](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-visit-comments", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_SERVICE_VISIT_COMMENT](context, payload) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("service-visit-comments", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_SERVICE_VISIT_COMMENT](context, params) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.update("service-visit-comments", params.id, params.payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_SERVICE_VISIT_COMMENT](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("service-visit-comments", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_SERVICE_VISIT_COMMENT_OPTIONS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-visit-comments/visit-options" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
      });
    });
  },
  [FETCH_SERVICE_VISIT_COMMENT_STATUSES]() {
    return ApiService.get("service-visit-comments/status-options")
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },
  [UPDATE_SERVICE_VISIT_COMMENT_STATUS](context, params) {
    return ApiService.put(`service-visit-comments/${params.id}/status`, {
      statusId: params.statusId
    })
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  }
};

const mutations = {
  [SET_LOADING](state, value) {
    state.isLoadingServiceVisitComment = value;
  },
  [SET_SERVICE_VISIT_COMMENTS](state, data) {
    state.isLoadingServiceVisitComment = false;
    state.serviceVisitComments = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
